<template>
  <page>
    <v-card>
      <v-toolbar v-if="newGLAnCode" dense color="grey lighten-3" flat>
        <v-icon>mdi-plus</v-icon>
        <v-toolbar-title>Create New GL Analysis Code</v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
        <v-icon>mdi-pencil</v-icon>
        <v-toolbar-title>Edit GL Analysis Code </v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Query GL Analysis Code </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs6>
              <v-autocomplete
                :readonly="queryMode"
                :label="labels.glAnType"
                :items="glAnTypes"
                v-model="glAnCodeForm.glAnType"
                item-text="label"
                item-value="value"
                data-vv-name="glAnType"
                :data-vv-as="labels.glAnType"
                v-validate="'required'"
                :error-messages="errors.collect('glAnType')"
              ></v-autocomplete>
              <v-text-field
                :readonly="queryMode"
                v-model="glAnCodeForm.glAnCode"
                :label="labels.glAnCode"
                :error-messages="errors.collect('glAnCode')"
                data-vv-name="glAnCode"
                :data-vv-as="labels.glAnCode"
                v-validate="'required|max:2'"
              ></v-text-field>
              <v-text-field
                :readonly="queryMode"
                v-model="glAnCodeForm.glAnDesc"
                :label="labels.glAnDesc"
                :error-messages="errors.collect('glAnDesc')"
                data-vv-name="glAnDesc"
                :data-vv-as="labels.glAnDesc"
                v-validate="'required|max:25'"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ glAnCodeForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ glAnCodeForm.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!newGLAnCode">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ glAnCodeForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ glAnCodeForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="doCancel">
          <span>Cancel</span>
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" v-if="!queryMode" dark @click="doSave">
          Save GL Analysis Code
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      labels: {
        glAnType: 'GL Analysis Type',
        glAnCode: 'GL Analysis Code',
        glAnDesc: 'Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      glAnCodeForm: {
        glAnCode: null,
        glAnType: null,
        glAnDesc: null,
        createdBy: null,
        createdDate: null
      },
      glAnTypes: [
        { label: 'CR - Country of Risk', value: 'CR' },
        { label: 'CA - Country of Agent', value: 'CA' },
        { label: 'CC - Country of Cedant', value: 'CC' },
        { label: 'CF - Country of Reinsurer', value: 'CF' },
        { label: 'PT - Policy Type', value: 'PT' },
        { label: 'BC - Business Class', value: 'BC' },
        { label: 'BH - Branch', value: 'BH' },
        { label: '51 - Client 1', value: '51' },
        { label: '52 - Client 2', value: '52' },
        { label: 'DT - Department', value: 'DT' }
      ],
      newGLAnCode: true,
      old: null,
      reviewMode: false,
      queryMode: false
    }
  },
  created() {
    if (this.glAnCodeMode === 'Review') {
      this.reviewMode = true
    } else if (this.glAnCodeMode === 'Query') {
      this.queryMode = true
    }
    this.doInit()
  },
  methods: {
    async doInit() {
      var glAnType = this.$route.params.glAnType
      var glAnCode = this.$route.params.glAnCode
      if (glAnCode && glAnType) {
        this.newGLAnCode = false
        const data = {
          glAnCode: glAnCode,
          glAnType: glAnType
        }
        this.fetchData(data)
      } else {
        this.newGLAnCode = true
        var formData = {
          glAnType: null,
          glAnCode: null,
          glAnDesc: null,
          createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
          createdDate: new Date(),
          modifiedBy: null,
          modifiedDate: null
        }
        this.glAnCodeForm = formData
      }
    },
    async fetchData(data) {
      const apiURI = this.menu.glAnCode
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, data))
        if (result.data) {
          this.setData(result.data)
        }
      }
    },
    async doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const config = {
            method: this.newGLAnCode ? 'post' : 'put',
            url: this.newGLAnCode ? this.menu.glAnCodeCreate : this.menu.glAnCodeUpdate,
            data: this.glAnCodeForm
          }
          if (this.newGLAnCode) {
            config.method = 'post'
            config.url = this.menu.glAnCodeCreate
          } else {
            config.method = 'put'
            config.url = this.menu.glAnCodeUpdate
            config.data.old = this.old
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.newGLAnCode = false
                this.$router.push({ name: 'glAnCode' })
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    setData(dataMap) {
      var formData = {
        glAnType: dataMap.glanType,
        glAnCode: dataMap.glanCode,
        glAnDesc: dataMap.glanDesc,
        createdBy: dataMap.createdBy,
        createdDate: dataMap.createdDate,
        modifiedBy: dataMap.modifiedBy,
        modifiedDate: dataMap.modifiedDate
      }
      this.glAnCodeForm = formData
      this.old = Object.assign({}, formData)
    },
    doCancel() {
      this.$router.push({ name: 'glAnCode' })
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAnCode.menu
    },
    glAnCodeMode() {
      return this.$route.params.glAnCodeMode
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [MessageMixin]
}
</script>
